import React from 'react';

class HoverLabel extends React.Component {
  shouldComponentUpdate(newProps) {
    const { props } = this;

    if (props.item != newProps.item) {
      return true;
    }

    if (props.hoverLabels != newProps.hoverLabels) {
      return true;
    }

    return false;
  }

  render() {
    const { item, hoverLabels } = this.props;

    if (!hoverLabels || !item) {
      return null;
    }

    const label = (!!item.label ? item.label.toString() : undefined) || '';

    const width = 20 * label.length + 20;

    return (
      <g className="hover-label" style={{ transition: 'all 100ms ease-out' }}>
        <rect className="background" x={-(width * 0.5)} height={50} width={width} />
        <text className="label" x={0} y={0} textAnchor="middle">
          {label}
        </text>
      </g>
    );
  }
}

HoverLabel.defaultProps = {
  hoverLabels: false
};

export default HoverLabel;
